import { Injectable } from '@angular/core';
import { AbstractControl, FormControl, FormGroup, Validators } from '@angular/forms';
import { AsyncValidationService } from './async-validation.service';
// import { QuestionBase } from './models/question-base.model';


@Injectable()
export class QuestionControlService {
  constructor(private async_validation: AsyncValidationService) { }

  toFormGroup(fieldGroup: any, action) {
    let group: any = {};
    fieldGroup.forEach(formg => {
      formg.questions.forEach(question => {

        if (action == 'VIEW')
          question['disabled'] = true;
        if (this.isArray(question)) {
          var blockGroup = this.toFormGroup(question, action);
          if (blockGroup.controls != undefined) {
            for (let key in blockGroup.controls) {
              group[key] = blockGroup.controls[key];

            }
          }
        } else {
          question.updateOn = 'submit';
          if (question.component == 'numberbox' || question.controlType == 'numberbox') {
            if (question.setDefault) {
              group[question.key] = question.visible == true && question.required ? new FormControl(question.value || 0, Validators.required) //Author saurav deep this will send 0 to backend (it will set value 0 to form for number type)
                : new FormControl(question.value || 0);
            } else {
              group[question.key] = question.visible == true && question.required ? new FormControl(question.value != undefined ? question.value : '', Validators.required)
                : new FormControl(question.value != undefined ? question.value : '');
            }
          } else if (question.controlType == 'edit_grid') {
            group[question.key] = new FormControl(question.value || []);
          }
          else if (question.component == 'composite-array' || question.controlType == 'composite-array') {
            //Author saurav deep this will send [] to backend (it will set value [] to form for composite array type)
            group[question.key] = question.visible == true && question.required ? new FormControl(question.value || [], Validators.required)
              : new FormControl(question.value || []);
          }
          else if ((question.component == 'fileuploader' || question.controlType == 'fileuploader') && question.visible == true && question.multiple == true) {
            group[question.key] = question.visible == true && question.multiple == true && question.required != undefined && question.required ? new FormControl(question.value || [], Validators.required)
              : new FormControl(question.value || []);
          }
          else if (question.controlType == 'daterangepicker' && !question.singleDatePicker && question.required) {
            group[question.key] = question.visible == true ? new FormControl(question.value || '', this.dateRangeValidator(question))
              : new FormControl(question.value || '');
          }
          else if (question.controlType == 'hidden' &&(question.type == 'array' || question.type == 'Array')) {
            group[question.key] = new FormControl(question.value || []);
          }
          else {
            group[question.key] = question.visible == true && question.required ? new FormControl(question.value || '', Validators.required)
              : new FormControl(question.value || '');
          }
        }
        // }
      });
    });

    return new FormGroup(group);
  }

  isArray(obj) {
    return obj instanceof Array;
  }

  dateRangeValidator(question) {
    return (control: AbstractControl): { [key: string]: boolean } | null => {
      if (control.value != null && control.value[question.startKey] !== undefined && control.value[question.endKey] !== undefined && control.value[question.startKey] && control.value[question.endKey]) {
        return null;
      }
      return { 'dateRangeValidator': true }
    };
  }
}
